function Typography() {
  return {
    fontFamily: '"Lato", sans-serif',
  };
}

export default Typography;
